import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.VALIDATED_VISIBILITY_ASSETS_GET_REQUEST: {
            return state;
        }
        case actionTypes.VALIDATED_VISIBILITY_ASSETS_GET_SUCCESS: {
            const { assetAuditor } = action.payload;
            return helpers.addListReducer(state, assetAuditor[0]);
        }
        case actionTypes.VALIDATED_VISIBILITY_ASSETS_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.VALIDATED_VISIBILITY_ASSETS_ITEM_SET: {
            const { audit } = action.payload;
            return { ...state, item: audit };
        }
        default: {
            return state;
        }
    }
}
